import {create} from 'zustand'
import {
    CheckInOutPair,
    EmployeeEvents,
    EmployeeInline,
    WorkEventKindEnum as KindEnum,
    WorkEventInline,
    WorkEventOutput
} from "@src/httpClient/__generated__/Api.ts";
import {LocalEvent} from "@src/db.ts";
import {AxiosError} from "axios";


export interface GroupedEventsResponse {
    results: EmployeeEvents[],
    count: number,
    __source: "online" | "offline"
}

export type CommonEventType = WorkEventOutput | LocalEvent | WorkEventInline
export type CommonEventsList = WorkEventOutput[] | LocalEvent[] | WorkEventInline[]

interface EventsStore {
    groupedEvents: CheckInOutPair[],
    employeeEvents: EmployeeEvents[],
    setGroupedData: (data: EmployeeEvents[]) => void,
    lastEventStatus: KindEnum,
    refetch?: () => void
    error?: AxiosError
    setError: (error?: AxiosError) => void
    isLoading: boolean
    setIsLoading: (isLoading: boolean) => void
    addRefetchAction: (ref: any) => void
}

export const useEventsStore = create<EventsStore>((set) => ({
    isLoading: false,
    error: undefined,
    setError: (error?: AxiosError) => set({error}),
    setIsLoading: (isLoading: boolean) => set({isLoading}),
    groupedEvents: [],
    employeeEvents: [],
    addRefetchAction: (ref: any) => set({refetch: ref}),
    setGroupedData: (employeeEvents: EmployeeEvents[]) => {
        const groupedEvents: CheckInOutPair[] = []
        for (const ee of employeeEvents) {
            for (const pair of ee.events) {
                groupedEvents.push(pair)
            }
        }

        let lastEventStatus = KindEnum.Out
        if (groupedEvents.length > 0) {
            const last = groupedEvents[groupedEvents.length - 1]
            if (last.event_in && !last.event_out) lastEventStatus = KindEnum.In
        }

        set({employeeEvents, groupedEvents, lastEventStatus})
    },
    lastEventStatus: KindEnum.Out
}))

/** Offline fallback: group flat events into CheckInOutPair[] (server format) */
export const makeGroupEventsOffline = (events: CommonEventsList, employee?: EmployeeInline): CheckInOutPair[] => {
    const groupedEvents: CheckInOutPair[] = [];
    let openIn: CommonEventType | undefined;
    for (const punch of events) {
        if (punch.kind === KindEnum.In) {
            if (openIn) {
                groupedEvents.push({
                    event_in: openIn as WorkEventInline,
                    event_out: null,
                    date: openIn?.recorded_at,
                    worktime_length: null
                });
            }
            openIn = punch;
        } else {
            if (openIn) {
                groupedEvents.push({
                    event_in: openIn as WorkEventInline,
                    event_out: punch as WorkEventInline,
                    date: openIn?.recorded_at,
                    worktime_length: null
                });
                openIn = undefined;
            } else {
                groupedEvents.push({
                    event_in: null,
                    event_out: punch as WorkEventInline,
                    date: punch?.recorded_at,
                    worktime_length: null
                });
            }
        }
    }
    if (openIn) {
        groupedEvents.push({
            event_in: openIn as WorkEventInline,
            event_out: null,
            date: openIn?.recorded_at,
            worktime_length: null
        });
    }
    return groupedEvents;
}
